// 获取element-ui定义好的scroll盒子
export const selectRollLoad = {
  inserted:function (el,binding){
    const SELECT_WRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECT_WRAP_DOM.addEventListener('scroll', function () {

      const CONDITION = this.scrollHeight - (this.scrollTop + 1)<= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
}
